export const NETWORK = "mainnet-beta";
export const CANDY_MACHINE_ID = "CtJEctGUsbn8jZumsKQaJ8XDSDusd8XE2BCeeC4XYy4h";
